import Route from '@ember/routing/route';

export default class AuthRoute extends Route {}
